import { z } from "zod";

export const tipoDeSolicitacaoLgpdSchema = z.enum(["EXPORTACAO", "RESET_DADOS", "EXCLUSAO"]);
export type TipoDeSolicitacaoLgpd = z.infer<typeof tipoDeSolicitacaoLgpdSchema>;

/** Pedido de reset ou exclusão feito pelo titular. Confirma com a senha; conta só com
 *  Google/Microsoft (sem senha) confirma digitando o próprio e-mail. */
export const pedirSolicitacaoLgpdSchema = z.object({
  tipo: z.enum(["RESET_DADOS", "EXCLUSAO"]),
  senha: z.string().max(200).optional(),
  emailDeConfirmacao: z.string().trim().max(320).optional(),
  motivo: z.string().trim().max(500).optional(),
});
export type PedirSolicitacaoLgpdInput = z.infer<typeof pedirSolicitacaoLgpdSchema>;

export const ROTULO_DO_TIPO_LGPD: Record<TipoDeSolicitacaoLgpd, string> = {
  EXPORTACAO: "Exportação dos dados",
  RESET_DADOS: "Reset dos dados",
  EXCLUSAO: "Exclusão da conta",
};

/**
 * O que fazer com os pedidos de prótese de uma organização que está sendo limpa: o que ela mandou
 * pra um laboratório de outra organização fica (o laboratório precisa do histórico de produção e
 * cobrança), com o paciente anonimizado; o resto é apagado. Pedido que ela RECEBEU como laboratório
 * é da clínica que mandou e não entra aqui.
 */
export function decidirPedidosNaLimpeza(
  organizationId: string,
  pedidos: { id: string; labOrganizationId: string | null }[],
): { apagar: string[]; anonimizar: string[] } {
  const apagar: string[] = [];
  const anonimizar: string[] = [];
  for (const p of pedidos) {
    if (p.labOrganizationId && p.labOrganizationId !== organizationId) anonimizar.push(p.id);
    else apagar.push(p.id);
  }
  return { apagar, anonimizar };
}

export const PACIENTE_REMOVIDO = "Paciente removido";
